

import ImageSlider from './ImageSlider'; 


import ICLImage1 from '../assets/images/facilities/ICL/01.jpg';
import ICLImage2 from '../assets/images/facilities/ICL/02.jpg';
import ICLImage3 from '../assets/images/facilities/ICL/03.jpg';
import ICLImage4 from '../assets/images/facilities/ICL/04.jpg';

const images = [
    { src: ICLImage1, altText: 'ICL' },
    { src: ICLImage2, altText: 'ICL' },
    { src: ICLImage3, altText: 'ICL' },
    { src: ICLImage4, altText: 'ICL' },
   
];

const MultipurposeHall = () => {
    return (
        <section className="ftco-section ftco-no-pt ftco-no-pb"> 
            <div className="container">
                <div className="row justify-content-center mt-3 pb-4">
                    <div className="col-md-12 heading-section ftco-animate text px-4">
                        <h2 className="mb-4 text-success text-center">
                        📖 ICL - Information Center & Learning
                        </h2>   
                    </div>
                </div>
                
                <div className="row mt-3">
                    <div className="col-md-8 order-md-first wrap-about">
                        <div className="text px-4">
                            <p>
                            The Information Center & Learning (ICL) at SRN serves as a dynamic hub for knowledge, research, and digital learning. It is designed to support students in developing critical thinking, research skills, and independent learning habits through access to a wide range of resources.
                            </p>
                            <p>

                            🌟 Key Features of ICL: <br/>

✅ Extensive Library Collection – A vast range of books, journals, and reference materials.<br/>
✅ Digital Learning Resources – Access to e-books, online research databases, and educational software.<br/>
✅ Quiet Study Zones – Dedicated spaces for focused learning and research.<br/>
✅ Interactive Learning Tools – Smartboards, projectors, and multimedia content.<br/>
✅ Computer Access – Workstations for research, assignments, and online learning.<br/>
✅ Group Discussion Areas – Spaces for collaborative learning and brainstorming.<br/><br/>

📚 Available Resources:<br/>

🔹 Books & Magazines – Fiction, non-fiction, academic books, and periodicals.<br/>
🔹 E-Library Access – Digital textbooks and online educational portals.<br/>
🔹 Research & Reference Materials – Encyclopedias, journals, and academic papers.<br/>
🔹 Multimedia Learning – Educational videos, audiobooks, and online courses.<br/>
🔹 Career Guidance Materials – Resources to help students with career planning and skill development.<br/><br/>

📢 ICL Guidelines:<br/>

📍 Maintain silence and respect the learning environment.<br/>
📍 Handle books and digital resources with care.<br/>
📍 Use computers and the internet responsibly.<br/>
📍 Return borrowed materials on time.<br/>
📍 Collaborate respectfully in discussion areas.<br/><br/>

The ICL - Information Center & Learning is a gateway to knowledge and innovation, helping students enhance their learning experience beyond the classroom.<br/>

📍 Location: ICL Block
🕒 Timings: 9 A.M - 3 P.M
📞 Contact: ICL Coordinator

We invite students to explore, learn, and grow through the wealth of resources available at the ICL!
                            </p>
                        </div>
                    </div>
                    <div className=" col-md-4 order-md-first wrap-about">
                    <ImageSlider images={images} />              
                    </div>
                </div>  
            </div>
            <hr className="custom-hr"/>
        </section>
    );
};

export default MultipurposeHall;
